define(['common/widgets/bc.ajaxloader'], function() {
  $.widget('bc.loadingtext', {
    options: {
      loadingClass: 'loading-primary',
      loadingMessage: '',
      postLoadMessage: '',
      timeShowPostLoadMessage: 0,
      size: 'small',
      style: 'dark',
      inject: 'insertAfter',
      position: 'right',
    },

    _create() {
      var self = this;

      if (BC.site.code === 'bcs') {
        self.$loadingAnimation = $('<div/>').addClass(self.options.loadingClass);
      } else {
        self.element.ajaxloader({
          inject: self.options.inject,
          position: self.options.position,
          size: self.options.size,
          style: self.options.style,
        });
      }
      self.originalMessage = self.element.text();
    },

    hide(showPostLoadMessage) {
      var self = this;
      var postMessage = showPostLoadMessage && self.options.postLoadMessage;

      self.element.text(postMessage || self.originalMessage);

      if (BC.site.code === 'bcs') {
        self.$loadingAnimation.remove();
      } else {
        self.element.ajaxloader('hide');
      }

      if (postMessage) {
        setTimeout(function() {
          self.element.text(self.originalMessage);
        }, self.options.timeShowPostLoadMessage);
      }
    },

    show() {
      var self = this;

      self.element.text(self.options.loadingMessage);
      if (BC.site.code === 'bcs') {
        self.element.append(self.$loadingAnimation);
      } else {
        self.element.ajaxloader('show');
      }
    },
  });
});
